import { render, staticRenderFns } from "./UniversityCourseList.vue?vue&type=template&id=4a569f6a"
import script from "./UniversityCourseList.vue?vue&type=script&lang=js"
export * from "./UniversityCourseList.vue?vue&type=script&lang=js"
import style0 from "./UniversityCourseList.vue?vue&type=style&index=0&id=4a569f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports